<template>
  <section class="ra-version-selector">
    <p class="ra-version-selector__lead">
      はじめに、子どもの月齢や年齢に合わせて「妊娠・出産期」「乳幼児期」どちらかの入力シートをお選びください。
    </p>
    <v-radio-group
      class="ra-version-selector__radios"
      :model-value="modelValue"
      :disabled="disabled"
      inline
      hide-details
      @update:model-value="handleSelect"
    >
      <v-radio
        v-for="version in versions"
        :key="version.versionType"
        :label="version.label"
        :value="version.versionType"
        color="black"
      />
      <!-- どちらの入力シートにも該当しない場合。設問に答えずに完了し、ハイリスク疑い報告へ進める。 -->
      <v-radio
        v-if="skipLabel"
        :label="skipLabel"
        :value="SKIPPED_VERSION_TYPE"
        color="black"
      />
    </v-radio-group>
    <p class="ra-version-selector__note">
      ※子が複数いる場合など、バージョンの判断に迷った場合は、対象となる子の月齢・年齢に近い方をお選びください。
    </p>
    <p class="ra-version-selector__note">
      ※リスクアセスメントについての詳細は「Kids Public相談員共通マニュアル『リスクアセスメントを行う』」または「<a
        :href="OFFICIAL_MANUAL_URL"
        class="ra-version-selector__link"
        target="_blank"
        rel="noopener noreferrer"
      >成育医療研究センター公式マニュアル</a>」をご参照ください。
    </p>
  </section>
</template>

<script setup lang="ts">
import { SKIPPED_VERSION_TYPE, type RiskAssessmentVersion } from "@/vue/entities/risk-assessment";

// URLのハードコードについてはリンク切れの可能性を許容する
const OFFICIAL_MANUAL_URL = "https://familyhealth.ncchd.go.jp/manuals/#manual-section";

defineProps<{
  versions: RiskAssessmentVersion[];
  modelValue: number | null;
  skipLabel?: string;
  disabled?: boolean;
}>();

const emit = defineEmits<{
  "update:modelValue": [number];
  "report-requested": [];
}>();

const handleSelect = (value: unknown): void => {
  if (typeof value !== "number") return;

  emit("update:modelValue", value);
};
</script>

<style lang="scss" scoped>
.ra-version-selector {
  border: 1px solid #f0c3cc;
  border-radius: 4px;
  padding: 12px 16px;
}

.ra-version-selector__lead {
  text-align: center;
  font-size: 14px;
  margin-bottom: 4px;
}

.ra-version-selector__radios {
  display: flex;
  justify-content: center;

  :deep(.v-selection-control-group) {
    justify-content: center;
    gap: 40px;
  }
}

.ra-version-selector__note {
  font-size: 11px;
  color: rgba(0, 0, 0, 0.6);
  margin-top: 4px;
}

.ra-version-selector__link {
  color: rgba(0, 0, 0, 0.6);
  text-decoration: underline;
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
}
</style>
